// Transformers for the REGA Ad License visibility feature (Bayut KSA only).
// Response shapes follow the 30 Sep FE contract (Rehman Ali) / Legion PR #14097.

// Summary may arrive with `fal_verified: false` alone — counts and assistance
// can be missing, so default them rather than letting the UI read undefined.
export const regaAdLicensesSummaryTransformer = (response) => ({
  fal_verified: response?.fal_verified ?? false,
  unposted_count: response?.unposted_count ?? 0,
  ready_to_post_count: response?.ready_to_post_count ?? 0,
  assistance: {
    available: response?.assistance?.available ?? false,
    requested: response?.assistance?.requested ?? false,
  },
});

export const regaAdLicensesListTransformer = (response) => ({
  list: response?.rega_ad_licenses || [],
  pagination: response?.pagination || {},
});

export const regaAdLicenseDetailTransformer = (response) => response?.rega_ad_license || {};
